// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Typeahead_dropdownMenu__l3LqQ {
    background: var(--color-lightui-surface-1);
    border: 1px solid var(--color-lightui-accent-2);
    border-radius: 0;
    box-shadow: 0 2px 5px rgb(0 0 0 / 10%);
    color: var(--color-icon-secondaryDark);
    font-size: 12px;
    letter-spacing: 0.03em;
    list-style: none;
    margin: 2px 0 0;
    max-height: 350px;
    min-width: 160px;
    overflow: auto;
    padding: 5px 0;
    position: absolute;
    z-index: 11;
}

.Typeahead_dropdownMenu__l3LqQ li {
    border-bottom: 1px solid var(--color-lightui-surface-3);
    line-height: 18px;
    padding: 3px 20px;
    position: relative;
}

.Typeahead_dropdownMenu__l3LqQ li:hover {
    background: var(--color-primary);
    color: white;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Typeahead/Typeahead.module.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,+CAA+C;IAC/C,gBAAgB;IAChB,sCAAsC;IACtC,sCAAsC;IACtC,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uDAAuD;IACvD,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".dropdownMenu {\n    background: var(--color-lightui-surface-1);\n    border: 1px solid var(--color-lightui-accent-2);\n    border-radius: 0;\n    box-shadow: 0 2px 5px rgb(0 0 0 / 10%);\n    color: var(--color-icon-secondaryDark);\n    font-size: 12px;\n    letter-spacing: 0.03em;\n    list-style: none;\n    margin: 2px 0 0;\n    max-height: 350px;\n    min-width: 160px;\n    overflow: auto;\n    padding: 5px 0;\n    position: absolute;\n    z-index: 11;\n}\n\n.dropdownMenu li {\n    border-bottom: 1px solid var(--color-lightui-surface-3);\n    line-height: 18px;\n    padding: 3px 20px;\n    position: relative;\n}\n\n.dropdownMenu li:hover {\n    background: var(--color-primary);\n    color: white;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownMenu": `Typeahead_dropdownMenu__l3LqQ`
};
export default ___CSS_LOADER_EXPORT___;
